import Select from "react-select";
import { allowSave, Option } from "../../../store/helpers";
import React, { useEffect, useState } from "react";
import { RootState } from "../../../store/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { showModal } from "../../../reducers/modal/modal.actions";
import { updatePelaksana } from "../../../reducers/dokumenKerjasama/dokumenKerjasama.actions";
import { fieldErrorMessage, fieldHasErrors } from "../../../store/errorHandler";
import { PermissionMenuName } from "../../../interfaces/UserRole";

export const FormPelaksana = () => {
  const dispatch = useDispatch();
  const errors = useSelector((state: RootState) => state.dokumenKerjasama.error);
  const isLoading = useSelector((state: RootState) => state.dokumenKerjasama.isLoading);
  const listDepartment = useSelector((state: RootState) => state.department.listDepartment);
  const listDetailPelaksana = useSelector((state: RootState) => state.dokumenKerjasama.selectedDokumenKerjasama?.PELAKSANA_KERJASAMA);
  const listIdPelaksana = useSelector((state: RootState) => state.dokumenKerjasama.selectedDokumenKerjasama?.DEPT_ID);
  const [pelaksanaOptions, setPelaksanaOptions] = useState<Option[]>([]);
  
  const [selectedPelaksana, setSelectedPelaksana] = useState<Option | null>(null);

  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.dokumenKerjasama].ACCESS);
  const canSave = allowSave(role, 2);

  const onChangePelaksana = (e: Option | null) => {
    setSelectedPelaksana(e);
  }

  const addNewPelaksana = () => {
    if (!selectedPelaksana || !listIdPelaksana || typeof listDetailPelaksana === 'undefined' || typeof listIdPelaksana === 'undefined') {
      dispatch(showModal(
        'Partner gagal ditambahkan',
        'Mohon pilih partner terlebih dahulu.'
      ));
      return;
    }

    if (typeof listIdPelaksana.find((search) => search === selectedPelaksana.value) !== 'undefined') {
      dispatch(showModal(
        'Partner gagal ditambahkan',
        'Partner sudah terdaftar sebagai partner dalam dokumen kerjasama ini.'
      ));
      return;
    }

    const newPartner = listDepartment.find((search) => search.DEPT_ID === selectedPelaksana.value);

    if (newPartner) {
      const newPartnerIdList = [...listIdPelaksana];
      const newPartnerDetailList = [...listDetailPelaksana];
      newPartnerIdList.push(newPartner.DEPT_ID);
      newPartnerDetailList.push(newPartner);
      dispatch(updatePelaksana(newPartnerIdList, newPartnerDetailList));
    }
  }

  const removePelaksana = (id: string) => {
    if (!listIdPelaksana || typeof listDetailPelaksana === 'undefined' || typeof listIdPelaksana === 'undefined') {
      dispatch(showModal(
        'Partner gagal dihapus',
        'Sistem belum berhasil memuat data. Mohon coba kembali dalam beberapa saat.'
      ));
      return;
    }

    const newPartnerIdList = [...listIdPelaksana];
    const newPartnerDetailList = [...listDetailPelaksana];
    const removeTargetId = newPartnerIdList.findIndex((search) => search === id);
    const removeTargetList = newPartnerDetailList.findIndex((search) => search.DEPT_ID === id);

    newPartnerIdList.splice(removeTargetId, 1);
    newPartnerDetailList.splice(removeTargetList, 1);

    dispatch(updatePelaksana(newPartnerIdList, newPartnerDetailList));
  }

  useEffect(() => {
    const newOptions: Option[] = [];
    listDepartment.forEach(item => {
      newOptions.push({
        value: item.DEPT_ID.toString(),
        label: item.DEPT_NAME
      });
    });
    setPelaksanaOptions(newOptions);
  }, [listDepartment])

  const renderPelaksanaKerjasama = () => {
    if (listDetailPelaksana?.length === 0) {
      return (
        <tr>
          <td colSpan={2} style={{textAlign: 'center'}}>
            Data tidak ditemukan, silahkan tambah anggota baru.
          </td>
        </tr>
      );
    }

    return listDetailPelaksana?.map((item, index) => {
      return (
        <tr key={index}>
          <td>{item.DEPT_NAME}</td>
          <th>
            <button className="btn btn-danger btn-xs" disabled={isLoading || !canSave} onClick={() => removePelaksana(item.DEPT_ID)}>
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </th>
        </tr>
      );
    });
  }

  if (typeof listDetailPelaksana === 'undefined') return (
    <React.Fragment>
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Pelaksana Kerjasama</h3>
        </div>
        <div className="box-body">
          Sedang memuat data...
        </div>
        <div className="overlay active">
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Pelaksana Kerjasama</h3>
        </div>
        <div className="box-body">
          <div className={`form-group ${fieldHasErrors('DEPT_ID', errors) ? 'has-error' : ''}`}>
            <label>Pilih Nama Pelaksana Kerjasama</label>
            <div className="input-group">
              <Select
                isDisabled={isLoading || !canSave}
                options={pelaksanaOptions}
                onChange={onChangePelaksana}
                value={selectedPelaksana}
              />
              <span className="input-group-btn">
                <button type="button" className="btn btn-primary" disabled={isLoading || !canSave} onClick={addNewPelaksana}>
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </button>
              </span>
            </div>
            <span className="help-block">{ fieldErrorMessage('DEPT_ID', errors) }</span>
          </div>
        </div>
        <div className="box-body table-responsive no-padding" style={{ maxHeight: '200px' }}>
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="sticky">Nama <span className="text-red"><b>*</b></span></th>
                <th className="sticky"></th>
              </tr>
            </thead>
            <tbody>
              {renderPelaksanaKerjasama()}
            </tbody>
          </table>
        </div>
        <div className={`overlay ${isLoading ? 'active' : null}`}>
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </React.Fragment>
  );
};
